import React from "react";

export default function AdminField({
  label,
  required = false,
  help,
  error,
  children,
}) {
  return (
    <div>
      {label ? (
        <div className="mb-2 flex items-center justify-between gap-3">
          <label className="text-sm font-bold text-slate-800 dark:text-slate-100">
            {label}
            {required ? <span className="ml-1 text-rose-500">*</span> : null}
          </label>
        </div>
      ) : null}

      {children}

      {error ? (
        <p className="mt-2 text-xs font-bold text-rose-600 dark:text-rose-300">
          {error}
        </p>
      ) : help ? (
        <p className="mt-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
          {help}
        </p>
      ) : null}
    </div>
  );
}